module.exports = __webpack_public_path__ + "assets/img/9_133_big.09125d03.jpg";